
export const GET_REPORTING_DATA_REQUEST = 'GET_REPORTING_DATA_REQUEST';
export const GET_REPORTING_DATA_SUCCESS = 'GET_REPORTING_DATA_SUCCESS';
export const GET_REPORTING_DATA_FAILURE = 'GET_REPORTING_DATA_FAILURE';

export const UPDATE_REPORTING_CONSTANTS_REQUEST = 'UPDATE_REPORTING_CONSTANTS_REQUEST';
export const UPDATE_REPORTING_CONSTANTS_SUCCESS = 'UPDATE_REPORTING_CONSTANTS_SUCCESS';
export const UPDATE_REPORTING_CONSTANTS_FAILURE = 'UPDATE_REPORTING_CONSTANTS_FAILURE';
